// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"e08c45ad","298":"426ef52c","311":"147cca9f","323":"7d804437","360":"f814e164"}[chunkId] + ".chunk.js";
};